import { Button } from 'antd'
import CommentItem from './CommentItem'

/**
 * 回复列表展示组件
 * @param {{
 *  parentComment: object,
 *  replies: object[],
 *  onReply?: (reply)=>void,
 *  onLike?: (id)=>void,
 *  onExpand?: (parentId)=>void,
 *  isExpanded: boolean,
 *  onMentionClick?: (userId)=>void
 * }} props
 */
export default function ReplyList({ parentComment, replies, onReply, onLike, onExpand, isExpanded, onMentionClick }) {
  const visibleReplies = isExpanded ? replies : (replies || []).slice(0, 3)
  const total = parentComment?.replies?.total_count || (replies || []).length
  const showExpand = !isExpanded && total > 3
  const remainingCount = showExpand ? Math.max(total - (visibleReplies?.length || 0), 0) : 0
  return (
    <div style={{ paddingLeft: 32 }}>
      {visibleReplies.map((r) => (
        <CommentItem key={r.id} comment={r} onReply={(reply) => onReply?.(reply)} onLike={(id) => onLike?.(id)} onMentionClick={onMentionClick} />
      ))}
      {showExpand && (
        <Button type="link" onClick={() => onExpand?.(parentComment?.id)}>展开更多（{remainingCount}）</Button>
      )}
    </div>
  )
}